import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig } from "../../../services/api-config";
import axios from "axios";
import {API_SERVICE_TYPE_ROUTER} from "../../../services/api-config";

export enum ServiceTypeStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
  DELETED = 2,
}
export interface ServiceType {
  id: number;
  branch_id: number;
  code: string;
  name: string;
  description: string;
  status: ServiceTypeStatusCode;
  created_at: string;
  updated_at: string;
}

export interface CreateServiceTypePayload {
  branch_id: number;
  code: string;
  name: string;
  description?: string;
  status?: ServiceTypeStatusCode;
}

export interface ChangeServiceTypeStatusPayload {
  status: ServiceTypeStatusCode;
}

export interface ServiceTypeListFilters {
  status?: number;
  branch_id?: number;
  limit?: number;
  page?: number;
  key_search?: string;
}

export interface ServiceTypeListResponse {
  list: ServiceType[];
  total_record: number;
  limit?: number;
}
export interface UpdateServiceTypePayload {
  code?: string;
  name?: string;
  description?: string;
  status?: ServiceTypeStatusCode;
}
export async function GetServiceTypes(): Promise<ServiceType[]> {
  const res = await axios.get("/api/service-types");
  return res.data;
}
export const ServiceTypeService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceTypeListResponse>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return{
      fetch: (params: ServiceTypeListFilters = { status: -1 }) =>
        request({
          endPoint: API_SERVICE_TYPE_ROUTER.API_LIST,
          data: params,        
        }), 
        response: baseResponse,
        loading: loading,
    }
  },
  listActive: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceTypeListResponse>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (params: ServiceTypeListFilters = { status: 1 }) =>
        request({
          endPoint: API_SERVICE_TYPE_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ServiceType>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (payload: CreateServiceTypePayload) =>
        request({
          endPoint: API_SERVICE_TYPE_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  update: () => {
      const { request, baseResponse, loading } = useFetchData.Post<ServiceType>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });
      return {
        fetch: (id: number, payload: UpdateServiceTypePayload) =>
          request({
            endPoint: API_SERVICE_TYPE_ROUTER.API_UPDATE_SERVICE(id),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      };
    },
  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ServiceType>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number, payload: ChangeServiceTypeStatusPayload) =>
        request({
          endPoint: API_SERVICE_TYPE_ROUTER.API_CHANGE_STATUS_SERVICE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceType>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return{
      fetch: (id: number) =>
        request({
          endPoint: API_SERVICE_TYPE_ROUTER.API_DETAIL_SERVICE(id),
        }),
      response: baseResponse, 
      loading: loading,
    }
  },
};

export default ServiceTypeService;
